import { useQuery } from "@apollo/client";
import { Loading } from "@lyfegen-platform/react-common";
import { Box, useTheme } from "@material-ui/core";
import { ErrorOutline, InfoOutlined } from "@material-ui/icons";
import { memo, useState } from "react";
import { tryDeserialize } from "../../../utils/try-deserialize";
import { GET_CASELESS_REFUND_SOURCE_CONDITIONS } from "./queries";
import { Conditions, ConditionsTooltip, IRefundRelatedConditions } from "./RefundRelatedConditions";
import { GetCaselessRefundSourceConditionsQuery } from "./types/queries.generated";
import { LiteBox } from "../../../components/lite/LiteBox";

const CaselessRefundRelatedConditions = (props: IRefundRelatedConditions) => {
	const { agreementId, financialDataPoint, evaluationSnapshot } = props;
	const [open, setOpen] = useState(false);
	const { palette } = useTheme();
	const { data, loading, error } = useQuery<GetCaselessRefundSourceConditionsQuery>(GET_CASELESS_REFUND_SOURCE_CONDITIONS, {
		skip: !agreementId || !open,
		variables: { agreementId },
	});

	if (error) {
		return <ErrorOutline />;
	}

	if (!agreementId || (!financialDataPoint && !evaluationSnapshot)) {
		return null;
	}

	function handleSetOpen() {
		setOpen(true);
	}

	const agreementVersions = data?.baseAgreements || [];
	const conditionSnapshot =
		tryDeserialize(evaluationSnapshot || financialDataPoint?.evaluationSnapshot || null, { conditions: [] }) || [];

	return (
		<LiteBox display="flex" justifyContent="flex-start" borderLeft={`5px solid transparent`} width="100%" height="45px">
			<LiteBox display="flex" flexDirection="column" justifyContent="center">
				<ConditionsTooltip
					onOpen={handleSetOpen}
					title={
						loading || !agreementVersions.length ? (
							<Loading />
						) : (
							<Conditions
								agreementVersions={agreementVersions}
								snapshotObject={conditionSnapshot}
								dataContainers={agreementVersions[0].dataContainers}
							/>
						)
					}
					placement="right"
				>
					<InfoOutlined htmlColor={palette.primary.main} />
				</ConditionsTooltip>
			</LiteBox>
		</LiteBox>
	);
};

export default memo(CaselessRefundRelatedConditions);
